export enum MobileEnum {
  Large = 992,
  Medium = 768,
  Small = 576
}

